module.exports = __webpack_public_path__ + "img/6C.5c96f40f.png";